import { useEffect } from "react";
import L from "leaflet";

const MapaCamara = (props) => {
  const { camara } = props;

  useEffect(() => {
    const buildMap = async () => {
      if (!camara || !camara.latitud || !camara.longitud) {
        return;
      }

      let container = L.DomUtil.get("mapaCamara");
      if (container != null) {
        container._leaflet_id = null;
      }

      let map = L.map("mapaCamara", { attributionControl: false }).setView(
        [camara.latitud, camara.longitud],
        16
      );

      L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        minZoom: 11,
        maxZoom: 20,
      }).addTo(map);

      let cantidad = camara.infracciones_count;
      if (camara.latitud && camara.longitud) {
        let lengthCantidad = cantidad.toString().length;
        let iconAnchor;
        if (lengthCantidad > 2) {
          iconAnchor = (lengthCantidad * 11) / 2;
        } else if (lengthCantidad === 2) {
          iconAnchor = 13;
        } else if (lengthCantidad === 1) {
          iconAnchor = 9;
        }

        let color = cantidad === 0 ? "danger" : "success";

        L.marker([camara.latitud, camara.longitud], {
          icon: L.divIcon({
            className: "custom",
            html: `
            <div class="marker" style="
              font-family: Arial, Helvetica, sans-serif;
              font-weight: 900; 
              background-color: var(--${color}); 
              opacity: 1; 
              outline: 3px solid var(--${color}-active);
              border-radius: 0.375rem; 
              color: #FFF; 
              padding: 2px 5px;              
              display: inline-block;      
              text-align: center;         
              white-space: nowrap;        
              max-width: 100px;           
            ">
              ${cantidad}
            </div>`,
            iconSize: [0, 20],
            iconAnchor: [iconAnchor, 10],
          }),
        })
          .addTo(map)
          .bindTooltip(
            `
            <p style="font-size: .9rem; font-weight:bolder; margin-bottom: 0px;">
              Lugar: ${camara.lugar}
            </p>`,
            {
              permanent: false,
              direction: "top",
              offset: [0, -10],
            }
          );
      }

      // return () => map.remove();
    };

    buildMap();
  }, []);

  return (
    <div>
      {/* <h2 className="text-decoration-underline mb-3">Mapa de puntos</h2> */}
      <div id="mapaCamara" style={{ height: "200px" }}></div>
    </div>
  );
};

export default MapaCamara;
